import { QuestionnaireTemplate, FlattenedQuestion } from '../models/questionnaire.model';



export class QuestionnaireMapper {
  
  static flattenQuestionnaire(template: QuestionnaireTemplate): FlattenedQuestion[] {
    if (!template || !template.sections) return [];

    const flattenedQuestions: FlattenedQuestion[] = [];

    template.sections.forEach((section) => {
      section.subsections.forEach((subsection) => {
        subsection.questions.forEach((question) => {
          flattenedQuestions.push({
            sectionName: section.description,
            subSectionName: subsection.name,
            questionType: question.question_type,
            questionId: question.question_id,
            questionText: question.questiion_text, // Fix potential typo
            responseOptions: question.options ? question.options.map(opt => opt.text).join(', ') : '--'
          });
        });
      });
    });

    return flattenedQuestions;
  }
}